import React, { useState, useEffect } from "react";
import { Row, Col, Form, Label, Input, ButtonGroup } from "reactstrap";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { is_empty, is_email } from "../../config/validate";
import LabelChargeData from "../../components/Common/labelChargeData";
import showToast from "../../components/Common/viewNotification";
//redux
import { useSelector, useDispatch } from "react-redux";
import { saveNotificationEmail, editNotificationEmail, cleanNotificationEmail } from "../../store/actions";

const CustomerForm = ({ onClosing, isEdit, currentNotificationEmail, onLoad, statusOrders }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [email, setEmail] = useState({ value: "", error: "" });
  const [id, setId] = useState({ value: "", error: "" });
  const [status, setStatus] = useState(true);
  const [statusOrdersSelected, setStatusOrdersSelected] = useState([]);
  const [auth] = useState(JSON.parse(sessionStorage.getItem("user")));
  let [errors, setErrors] = useState([]);

  //#region storage
  const { loading, response, error } = useSelector(state => ({
    loading: state.NotificationsEmail.loadingSave,
    response: state.NotificationsEmail.response,
    error: state.NotificationsEmail.error,
  }));
  //#endregion

  useEffect(() => {
    if (!is_empty(error)) {
      showToast(error, "error", t("error:title"));
      dispatch(cleanNotificationEmail());
    }
  }, [error]);

  useEffect(() => {
    if (response !== null) {
      clearForm();
      onLoad();
      dispatch(cleanNotificationEmail());
      onClosing();
    }
  }, [response]);

  useEffect(() => {
    if (currentNotificationEmail) {
      setData();
    }
  }, [currentNotificationEmail]);

  const lsStatusOrder = () => {
    if (statusOrders.length > 0) {
      return statusOrders.map((item) => {
        return { value: item.id, label: item.name };
      });
    } else {
      return [];
    }
  };

  const changeStatusOrder = (selectedOptions) => {
    setStatusOrdersSelected(selectedOptions);
  };

  const handleSubmit = async () => {
    validate();
    if (errors.length === 0) {
      let values = {
        id: id.value,
        email: email.value,
        area: statusOrdersSelected.map(option => ({ id: option.value })),
        createdBy: auth.id.user.username,
        status: 1,
      };
      if (values.id) {
        await dispatch(editNotificationEmail(values));
      } else {
        await dispatch(saveNotificationEmail(values));
      }
    }
  };

  const validate = () => {
    errors = [];
    if (statusOrdersSelected.length === 0) {
      statusOrdersSelected.error = t("error:required");
      errors.push(statusOrdersSelected.error);
    }
    if (!is_email(email.value)) {
      email.error = t("notificationsEmail:errorEmail");
      errors.push(email.error);
    }
    setErrors(errors);
  };

  const clearForm = async () => {
    setId({ value: "", error: "" });
    setEmail({ value: "", error: "" });
    setStatusOrdersSelected([]);
  };

  const setData = () => {
    setId({ value: currentNotificationEmail.id, error: "" });
    setEmail({ value: currentNotificationEmail.email, error: "" });
    setStatus(currentNotificationEmail.status === 1 ? true : false);
    setStatusOrdersSelected(currentNotificationEmail.area.map(order => ({ value: order.id, label: order.name })));
  };

  return (
    <React.Fragment>
      <Form>
        <Row>
          <Col xs={12}>
            <div className="mb-3">
              <Label htmlFor="name">{t("notificationsEmail:lblEmail")}</Label>
              <Input
                autoComplete="new-text"
                type="text"
                className="form-control"
                value={email.value || ""}
                onChange={e => {
                  setEmail({ value: e.target.value, error: "" });
                }}
                invalid={!is_empty(email.error)}
              />
              <span className="small text-danger">{email.error}</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div className="mb-3">
              <Label htmlFor="name">{t("notificationsEmail:lblStatusOrder")}</Label>
              <Select
                name="area"
                options={lsStatusOrder()}
                value={statusOrdersSelected}
                onChange={changeStatusOrder}
                isMulti

              />
              <span className="small text-danger">{statusOrdersSelected.error}</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <LabelChargeData
              label={""}
              showloading={loading}
              title={t("global:registerloading")}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="modal-footer">
              <ButtonGroup>
                <button
                  type="button"
                  className="btn btn-info save-user"
                  disabled={loading}
                  onClick={handleSubmit}
                >
                  <i className=" fas fa-save me-1 " />
                  {t("global:save")}
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  disabled={loading}
                  onClick={() => {
                    onClosing(false);
                  }}
                >
                  {" "}
                  {t("global:close")}
                </button>
              </ButtonGroup>
            </div>
          </Col>
        </Row>
      </Form>
    </React.Fragment>
  );
};

export default withRouter(CustomerForm);
